import { useEffect, useRef, useState } from "react";
import { SiteSyles, useIsFullscreen, useIsVisible, useSite } from "../Context/SiteContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faTimes } from "@fortawesome/free-solid-svg-icons";
import { DrawOnText } from "../Landing/Landing";
import { InterfaceStyles } from "../Components/Interface";


export const SavantGarde = () => {

    return(
        <div style={{
            display:'flex',
            ...SiteSyles.column,
            gap:10,
        }}>
            <SavantGardeTrailer></SavantGardeTrailer>
        </div>
    );

};

const SavantGardeTrailer = () => {

    const videoRef = useRef<HTMLVideoElement>(null);
    const videoVisible = useIsVisible(videoRef);

    useEffect(()=>{
        videoVisible ? videoRef.current?.play() : videoRef.current?.pause();
    },[videoVisible]);

    const [expandVideo, setExpandVideo] = useState(false);

    const [startLit, setStartLit] = useState(false);

    return(
        <div 
            style={{
                ...SiteSyles.column,
                position:'relative',
                width:'100vw',
                height: !expandVideo ? '33vh' : '56.25vw',
                maxHeight: expandVideo ? '100vh' : '56.25vw',
                transition:'height 1s',
                overflow:'hidden',
                cursor: !expandVideo ? 'pointer' : undefined,
            }} 
            onClick={()=>{
                if(!expandVideo){
                    setExpandVideo(true);
                }
            }}
        >
            <div style={{
                display:'flex',
                flex:1,
            }}>
                <video 
                    ref={videoRef} 
                    playsInline 
                    muted={!expandVideo}
                    loop 
                    style={{
                        position:'absolute',
                        height:'100%',
                        width:'100%',
                        objectFit: 'cover',
                    }} 
                >
                    <source src="assets/savant-garde/savant-garde-trailer.mp4"></source>
                    <source src="assets/savant-garde/savant-garde-trailer.mov"></source>
                </video>
                <div style={{
                    position:'absolute',
                    right:0,
                    bottom:0,
                    width:40,
                    height:40,
                    ...InterfaceStyles.center,
                    pointerEvents: expandVideo ? undefined: 'none',
                    cursor:'pointer',
                }} onClick={()=>{
                    setExpandVideo(false);
                }}>
                    <FontAwesomeIcon icon={expandVideo ? faTimes : faExpand} style={{color:'white',textShadow:'0px 0px 2px #000'}}></FontAwesomeIcon>
                </div>
                <div style={{
                    display:'flex',
                    position:'absolute',
                    right: 20,
                    top: 20,
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'flex-end',
                    mixBlendMode:'plus-lighter',
                    filter:'blur(1px)',
                }}>
                    <DrawOnText text="Savant Garde" start={videoVisible} onComplete={()=>{
                        setTimeout(()=>setStartLit(true),300);
                    }}></DrawOnText>
                    <DrawOnText text="Literary Magazine Covers" start={startLit} style={{
                        fontSize:24,
                    }}></DrawOnText>
                </div>
            </div>
        </div>
    );

};